<script lang="ts">
  import { onMount, createEventDispatcher, onDestroy } from 'svelte';

  const dispatch = createEventDispatcher();
  export let url;
  export let shouldLoadLib: (...args: any[]) => boolean = () => true;
  let script: HTMLScriptElement;

  const shouldLoadLibrary = shouldLoadLib()

  onMount(async () => {
    if (!shouldLoadLibrary) {
        console.log(`Library from ${url} already loaded`)
        dispatch('loaded')
        return
    }

    script.addEventListener('load', () => {
      console.log(`Loaded script from '${url}'`);
      dispatch('loaded');
    })

    script.addEventListener('error', (event) => {
      console.error("something went wrong", event);
      dispatch('error');
    });
  });
  onDestroy(()=>{
    //script.parentElement.removeChild(script);
      console.log(`Unloaded script from '${url}'`);
  })
</script>

<svelte:head>
    {#if shouldLoadLibrary}
        <script async bind:this={script} src={url} />
    {/if}
</svelte:head>
